<template>
  <div>
    <BNav fill class="applications-nav">
      <!-- NOTE: NavItem で処理したいが、vue-router v4 では RouterLink から exact props が削除され、クエリパラメータの差分は無視されてしまう -->
      <!-- 上記を回避するため、自前で実装している -->
      <li
        v-for="(link, index) in links"
        :key="`link-${index}`"
        :class="{ 'has-count': link.count }"
        class="applications-nav-item"
      >
        <RouterLink
          :to="{ name: 'ApplicationsList', query: { tab: link.tab } }"
          class="applications-nav-link"
          :exact-active-class="isCurrentTab(link.tab) ? 'active' : ''"
        >
          {{ link.title }}
          <BBadge v-if="link.count > 0" pill variant="red" class="number-badge">
            {{ link.count }}
          </BBadge>
        </RouterLink>
      </li>
    </BNav>
  </div>
</template>

<script lang="ts">
import { Component, Prop, Vue } from "vue-facing-decorator";
import { ApplicationsListNavItem } from "@/types/application/ApplicationsListNavItem";
@Component
export default class ApplicationsNav extends Vue {
  @Prop({
    required: true,
    type: Array
  })
  links!: ApplicationsListNavItem[];

  isCurrentTab(tab: string) {
    return this.$route.query.tab === tab;
  }
}
</script>

<style lang="scss" scoped>
.applications-nav {
  border-bottom: 1px solid $gray-03;
}

.applications-nav-link {
  display: block;
  padding: 0.5rem 1rem;
}

.applications-nav-item {
  flex: 1 1 auto;
  font-size: 10px;
  text-align: center;
  background: $white;
  @media (min-width: 360px) {
    font-size: 12px;
  }

  &.has-count {
    position: relative;

    .applications-nav-link {
      &.active {
        &::after {
          display: none;

          .applications-nav & {
            display: none;
          }
        }
      }

      @keyframes rippleMotion {
        0% {
          background-color: rgba(#efb30e, 0.4);
          transform: translate(-50%, -50%) scale(1, 1);
        }

        100% {
          background-color: rgba(#efb30e, 0);
          transform: translate(-50%, -50%) scale(2, 2);
        }
      }

      &::after {
        .applications-nav & {
          display: block;
        }

        position: absolute;
        top: 50%;
        left: 50%;
        z-index: 99;
        display: none;
        width: 20px;
        height: 20px;
        pointer-events: none;
        content: "";
        border-radius: 50%;
        transition: opacity linear 0.4s;
        transform: translate(-50%, -50%);
        animation: rippleMotion 1.5s linear infinite;
      }
    }
  }

  :deep(a) {
    padding-right: 0;
    padding-left: 0;
    color: $gray-05;

    &.active,
    &:hover {
      color: $blue;
      border-bottom: 2px solid $blue;
    }
  }
}

.number-badge {
  font-weight: normal;
  vertical-align: 1px;
}
</style>
